module.exports = __webpack_public_path__ + "img/17_67.72a3d9ef.png";